import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { TriangleWarning } from "components/icons/TriangleWarning";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useUnlinkTransactionsMutation } from "store/apis/invoices";

export const InvoiceUnlinkModal = ({
  invoiceId,
  isOpen,
  invoiceType,
  close,
  transactionId,
}: {
  invoiceId: string;
  isOpen: boolean;
  close: () => void;
  invoiceType: "BILL" | "INVOICE";
  transactionId?: string;
}) => {
  const groupId = useCurrentGroupContext().uuid;
  const entityId = useCurrentEntityId();

  const [unlinkedTransaction, { isLoading: unlinkingTransaction }] =
    useUnlinkTransactionsMutation();

  const confirmUnlinkTransaction = async (e?: React.MouseEvent) => {
    e?.stopPropagation();
    if (!invoiceId) return;
    await unlinkedTransaction({
      groupId,
      entityId,
      invoiceId,
      financial_record_type: invoiceType,
      transaction_id: transactionId,
    });
    close();
  };

  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content size="small" onClick={(e) => e.stopPropagation()}>
        <Modal.Body>
          <div>
            <span className="t-text-orange t-flex t-items-center t-justify-center t-w-10 t-h-10 t-rounded-full t-shadow-[0px_0px_0px_4px_rgba(255,220,78,0.15)] t-border t-border-orange-20 t-border-solid t-bg-yellow-20">
              <TriangleWarning />
            </span>
            <p className="t-mb-2 t-text-subtext t-mt-5">
              {transactionId
                ? "Unlink transaction?"
                : "Unlink all transactions?"}
            </p>
            <div className="t-text-body-sm t-text-text-30">
              Unlinking the transaction{transactionId ? "" : "s"} may change the
              invoice status and will update the corresponding transaction's
              categorisation.
            </div>
          </div>
        </Modal.Body>
        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button>Cancel</Button>
          </Modal.RawClose>
          <Button
            isLoading={unlinkingTransaction}
            disabled={unlinkingTransaction}
            customType="primary"
            onClick={confirmUnlinkTransaction}
          >
            Confirm
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
